import { useEffect, useRef, useState } from 'react'
import ActivityCard from './ActivityCard'
import Filters from './Filters'
import ReactPaginate from 'react-paginate'

export default function Activities ({
  restUrl,
  category,
  strings,
  subjects,
  areas,
  ageGroups,
}) {
  const isEmbed = window.self !== window.top
  const url = new URL(window.location.href)
  const wrapperRef = useRef()
  const [posts, setPosts] = useState([])
  const [isFirstRender, setIsFirstRender] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [totalPages, setTotalPages] = useState(0)
  const [scrollOnFetch, setScrollOnFetch] = useState(false)
  const [filters, setFilters] = useState({
    subject: url.searchParams.get('subject') || '',
    area: url.searchParams.get('area') || '',
    ageGroup: url.searchParams.get('ageGroup') || '',
    search: url.searchParams.get('search') || '',
    currentPage: url.searchParams.get('currentPage') || 1,
    category: category,
  })

  const fetchPosts = async (shouldScroll = false) => {
    setIsLoading(true)

    if (shouldScroll && wrapperRef.current) {
      wrapperRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }

    try {
      const url = new URL(restUrl)

      const searchParams = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value) {
          acc[key] = value
        }
        return acc
      }, {})

      const params = new URLSearchParams(searchParams)

      url.search = params.toString()

      const response = await fetch(url)

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }

      const data = await response.json()

      setPosts(data?.data?.posts || [])
      setTotalPages(data?.data?.totalPages || 0)
    } catch (error) {
      console.error('Error fetching activities:', error)
    } finally {
      setIsLoading(false)
      setIsFirstRender(false)
    }
  }

  const handlePageClick = (event) => {
    const value = event.selected + 1

    setScrollOnFetch(true)
    setFilters(prevFilters => ({
      ...prevFilters,
      currentPage: value,
    }))

    url.searchParams.set('currentPage', value)
    window.history.replaceState({}, '', url)
  }

  useEffect(() => {
    fetchPosts(scrollOnFetch).catch(console.error)
    setScrollOnFetch(false)
  }, [filters])

  useEffect(() => {
    if (!wrapperRef.current) {
      return
    }

    const outerWrapper = wrapperRef.current.closest('.mtt-activities')
    outerWrapper?.querySelector('#mtt-activities__skeleton')?.remove()

  }, [])

  return (
    <div ref={wrapperRef} className={'mtt-activities__wrapper' +
      (isLoading ? ' mtt-activities--loading' : '')}>

      <Filters
        subjects={subjects}
        areas={areas}
        ageGroups={ageGroups}
        strings={strings}
        filters={filters}
        setFilters={setFilters}
      />

      <div className="mtt-activities__posts">
        {posts.map(post => (
          <ActivityCard
            setFilters={setFilters}
            key={post.id}
            post={post}
            strings={strings}
            isEmbed={isEmbed}
          />
        ))}

        {isFirstRender && (
          [...Array(12)].map((_, index) => (
            <div className="mtt-activities-card" key={index}>
              <div className="mtt-activities-card__image"></div>

              <div className="mtt-activities-card__content">
                <div className="skeleton skeleton--title"></div>
                <div className="skeleton"></div>
                <div className="skeleton skeleton--half"></div>
                <div className="skeleton"></div>
                <div className="skeleton skeleton--half"></div>
                <div className="skeleton"></div>
                <div className="skeleton"></div>
                <div className="skeleton skeleton--quarter"></div>
                <div className="skeleton skeleton--button"></div>
              </div>
            </div>
          ))
        )}
      </div>

      <ReactPaginate
        breakLabel="..."
        nextLabel={strings.next}
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={totalPages}
        previousLabel={strings.prev}
        renderOnZeroPageCount={null}
        forcePage={filters.currentPage - 1}
        className={'mtt-activities__pagination'}
      />

      {!isLoading && posts.length === 0 && (
        <div className="mtt-activities__no-posts">
          {strings.noPosts}
        </div>
      )}
    </div>
  )
}
